import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Button, ButtonGroup, Checkbox, ClickAwayListener, FormControl, FormControlLabel, Grid, Grow, InputLabel, MenuItem, MenuList, Popover, Popper, Radio, RadioGroup, Select, Stack, Tooltip, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import FileSaver from 'file-saver';
import { useEffect, useMemo, useRef, useState } from 'react';
import { emitCustomEvent } from 'react-custom-events';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import AutoSizer from 'react-virtualized-auto-sizer';
import * as XLSX from 'xlsx/xlsx.mjs';
import ColorConstants from '../../../defaults/ColorConstants';
import Events from '../../../defaults/Events';
import FieldNames from '../../../defaults/FieldNames.json';
import { useIFPRSGlobalContext } from '../../../IFPRSGlobalContext';
import { setFilterGeometry, setIsLocationFilterOnly } from '../../../redux/slices/filterSlice';
import ErrorService from '../../../services/ErrorService';
import FeatureService from '../../../services/FeatureService';
import GroupingService from '../../../services/GroupingService';
import PlannedActualsService from '../../../services/PlannedActualsService';
import {sortFeatureAttributesByDate} from "../../../utils/DateHelper";
import { generateFeatureDataPromise } from '../../../utils/DownloadHelper';
import { createFeatureObject, getSummaryFundingRowsByActionObjectIds, isFeaturePostFire } from '../../../utils/FeatureHelper';
import { getFeatureGroupItemsOrganized } from "../../../utils/GroupingHelper";
import { getBaseFuelsString } from "../../../utils/QueryHelper";
import Grouping from '../../grouping/Grouping';
import ListCard from '../../ListCard';
import { MapLegend } from "../popover/MapLegend";
import "./TreatmentActivityList.css";
import { setViewingActions, setViewingProjects } from "../../../redux/slices/menuSlice";
// import { GridLegacy as Grid } from '@mui/material';

const drawerWidth = 550;

const openedMixin = (theme, headerheight) => ({
  width: drawerWidth,
  top: headerheight + "px",
  left: 'auto',
  backgroundColor: ColorConstants.AvatarBackgroundColor,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  overflowY: 'hidden'
});

const closedMixin = (theme, headerheight) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  backgroundColor: ColorConstants.AvatarBackgroundColor,
  top: headerheight + "px",
  left: 'auto',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  height: '48px !important',
  backgroundColor: ColorConstants.WhiteAlien,
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open, headerheight }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme, headerheight),
      '& .MuiDrawer-paper': openedMixin(theme, headerheight),
    }),
    ...(!open && {
      ...closedMixin(theme, headerheight),
      '& .MuiDrawer-paper': closedMixin(theme, headerheight),
    }),
  }),
);

export default function TreatmentActivityList({onTreatmentSelected, onActivitySelected, isTreatment, selectedFeatures, setSelectedFeatures, 
  associateOpen, setAssociateOpen, setIsTreatment, setMode, setIsCreatingActualFeature, setIsCreatingPlannedFeature, setPlannedFeature, listOpen, setListOpen, userInfo, userRoleInfo, headerheight }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [actionOpen, setActionOpen] = useState(false);
  const anchorRef = useRef(null);
  const [countPopupAnchorEl, setCountPopupAnchorEl] = useState(null);
  const countPopupOpen = Boolean(countPopupAnchorEl);
  const countPopupID = countPopupOpen ? 'count-popover' : undefined;
  const [isGroupingsLoading,setIsGroupingsLoading] = useState(false);
  const [groupingsOpen, setGroupingsOpen] = useState(false);
  const [filteredFeatures, setFilteredFeatures] = useState([]);
  const treatments = useSelector((state) => state.treatments.visibleTreatments);
  const activities = useSelector((state) => state.activities.visibleActivities);
  const actualTreatments = useSelector((state) => {return state.actualsTreatments.visibleActualsTreatments});
  const actualActivities = useSelector((state) => state.actualsActivities.visibleActualsActivities);
  
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [groupingCounts, setGroupingCounts] = useState(222);
  const [featureGroupItems, setFeatureGroupItems] = useState([]);
  const [featureGroupIds, setFeatureGroupIds] = useState([]);
  const [featureGroups, setFeatureGroups] = useState([]);
  const [toggleRefresh, setToggleRefresh] = useState(false);
  let isGroupClick = false;
  let isActualsClick = false;
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
  const nifcToken = useSelector((state) => state.configuration.nifcToken);
  const [cardSize, setCardSize] = useState("short");
  const [isLoading, setIsLoading] = useState(false);
  const { setShowGlobalLoader, 
    polygonListCount, setPolygonListCount,
    lineListCount,  setLineListCount,
    pointListCount,  setPointListCount,
    sortByValue, setSortByValue } = useIFPRSGlobalContext();
  const [isFilterFuelsOnly, setIsFilterFuelsOnly] = useState(false);
  const isUserPostfire = useMemo(() => {return userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes}, [userInfo]);
  const [tempPolygonListCount, setTempPolygonListCount] = useState(polygonListCount ?? 0);
  const [tempLineListCount, setTempLineListCount] = useState((isUserPostfire || !isFilterFuelsOnly) ? (lineListCount ?? 0) : 0);
  const [tempPointListCount, setTempPointListCount] = useState((isUserPostfire || !isFilterFuelsOnly) ? (pointListCount ?? 0) : 0);
  const areListCountsDifferent = (tempPolygonListCount !== polygonListCount) ||
                                  ((isUserPostfire || !isFilterFuelsOnly) && (tempLineListCount !== lineListCount)) ||
                                  ((isUserPostfire || !isFilterFuelsOnly) && (tempPointListCount !== pointListCount));
  const [tempSortByValue, setTempSortByValue] = useState(sortByValue);
  const activeFilterCountValue = useSelector((state) => state.filter.activeFilterCount);
  const customFilterInUse = useSelector((state) => state.filter.isCustomFilterActive);
  const definitionExpression = useSelector((state) => state.filter.definitionExpression);
  const currentMapExtent = useSelector((state) => state.map.currentMapExtent);
  
  const isViewingActions = useSelector((state) => state.menu.viewingActions);
  const isViewingProjects = useSelector((state) => state.menu.viewingProjects);
  const [projectActionSelection,setProjectActionSelection] = useState(isViewingActions ? "Actions" : "Projects");

  useEffect(() => {
    setIsCheckAll(false);
    setSelectedFeatures([]);
    const baseFuelsString = getBaseFuelsString();
    if(definitionExpression && definitionExpression.includes(baseFuelsString)){
      setIsFilterFuelsOnly(true);
      setTempLineListCount(0);
      setTempPointListCount(0);
      setLineListCount(0);
      setPointListCount(0);
    } else {
      setIsFilterFuelsOnly(false);
      setTempLineListCount(25);
      setTempPointListCount(25);
      setLineListCount(25);
      setPointListCount(25);
    }
    
  }, [definitionExpression, currentMapExtent]);

  useEffect(() => {
    const plannedFeatures = treatments.concat(activities);
    const actualFeatures = actualTreatments.concat(actualActivities);
    const features = plannedFeatures.concat(actualFeatures);
    let sortedFeatures = features;
    if(features && features.length){
      if(sortByValue)
      {
        if(sortByValue.includes("FY"))
        {
          sortedFeatures = features.sort((a,b) => { 
            let firstItem = a[FieldNames.featureFields.completionFiscalYear] ? (a[FieldNames.featureFields.completionFiscalYear])
            : a[FieldNames.featureFields.initiationFiscalYear] ? (a[FieldNames.featureFields.initiationFiscalYear]) : "--";
            let secondItem = b[FieldNames.featureFields.completionFiscalYear] ? (b[FieldNames.featureFields.completionFiscalYear])
            : b[FieldNames.featureFields.initiationFiscalYear] ? (b[FieldNames.featureFields.initiationFiscalYear]) : "--";
            let sortRet = (firstItem > secondItem) ? 1 : (secondItem > firstItem) ? -1 : 0
            if(sortByValue.includes("DESC"))
            {
              sortRet *= -1;
            }
            return sortRet;
          });
          
        }
        else
        {
          const fieldSortByValue = sortByValue.replace(" ASC", "").replace(" DESC", "");
          sortedFeatures = features.sort((a,b) => { 
            let firstItem = a[fieldSortByValue];
            let secondItem = b[fieldSortByValue];
            if(!firstItem){
              firstItem = "";
            }
            if(!secondItem){
              secondItem = "";
            }
            firstItem = firstItem ? firstItem.toLowerCase() : '';
            secondItem = secondItem ? secondItem.toLowerCase() : '';
            let sortRet = (firstItem > secondItem) ? 1 : (secondItem > firstItem) ? -1 : 0
            if(sortByValue.includes("DESC"))
            {
              sortRet *= -1;
            }
            return sortRet;
          });
          
        }
      } 
      else
      {
        // sorted features feels redundant here as features will be mutated by the sort function, but to be safe we can set it to a new array reference to avoid further refactoring
        sortedFeatures = sortFeatureAttributesByDate(features, FieldNames.featureFields.initiationDate, false);
      }
    }

    setFilteredFeatures(sortedFeatures);
  }, [treatments, activities, actualTreatments, actualActivities, sortByValue]);

  useEffect(() => {
    if(isViewingActions && !isViewingProjects)
    {
      setProjectActionSelection("Actions");
    }
    else if(!isViewingActions && isViewingProjects)
    {
      setProjectActionSelection("Projects");
    }
  }, [isViewingActions, isViewingProjects])

  const handleActionToggle = () => {
    setActionOpen((prevOpen) => !prevOpen);
  };

  const handleActionClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setActionOpen(false);
  };

  const onAssociate = () => {
    setAssociateOpen(true);
  }

  const associateHandleClose = (isSaved) => {
    setAssociateOpen(false);
    setSelectedFeatures([]);
    setIsCheckAll(false);
    if(isSaved){
      setToggleRefresh(!toggleRefresh);
    } 
  }

  const onGroupEdit = (featureAttr) => {
    setIsGroupingsLoading(true);
    isGroupClick = true;
    setFeatureGroupIds([]);
    setFeatureGroups([]);
    setFeatureGroupItems([]);
    //This will still be ID due to the features at this point being from the View
    let geoType = featureAttr?.[FieldNames.featureFields.joinFeature] ?? FieldNames.joinFeatureValues.polygon;
    GroupingService.getAllGroupItemsForFeatures([featureAttr[FieldNames.featureFields.joinID]], geoType).then(currentFeatureGroupItems => {
      //currentFeatureGroupItems is all groups and group items for the treatment/activity we are on
      if(currentFeatureGroupItems && currentFeatureGroupItems.GroupItems && currentFeatureGroupItems.GroupItems.length > 0){
        const groups = currentFeatureGroupItems.Groups;
        if(groups && groups.length > 0){
          const allGroupIds = groups.map((ea) => ea[FieldNames.treatmentActivityGroups.id]);
          setFeatureGroupIds(allGroupIds);
          setFeatureGroups(groups);
          const newFeatureAttr = Object.assign({}, featureAttr);
          newFeatureAttr[FieldNames.featureFields.hasGroup] = FieldNames.yesNo.yes;
          newFeatureAttr[FieldNames.featureFields.groupCount] = allGroupIds.length;

          FeatureService.updateFeatureAttributes([newFeatureAttr]).then(resp => {
            if(resp && resp.updateResults && resp.updateResults.length > 0 && resp.updateResults[0].success){
              
              GroupingService.getAllGroupItemsByGroupIds(allGroupIds).then(items => {
                //All Group Items in the groups that this treatment/activity has access to
                if(items && items.length > 0){
                  getFeatureGroupItemsOrganized(items, setFeatureGroupItems, userInfo, rootServiceUrl, config, nifcToken);
                  setGroupingsOpen(true);
                  setIsGroupingsLoading(false);
                }
              }).catch(error => {
                ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
              });
            }
          }).catch(error => {
            ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
          });
        }
      } else {
        const newFeatureAttr = Object.assign({}, featureAttr);
        newFeatureAttr[FieldNames.featureFields.hasGroup] = FieldNames.yesNo.no;
        newFeatureAttr[FieldNames.featureFields.groupCount] = 0;
        FeatureService.updateFeatureAttributes([newFeatureAttr]).then(resp => {
          if(resp && resp.updateResults && resp.updateResults.length > 0 && resp.updateResults[0].success){
          }
        }).catch(error => {
          ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
        });
      }
    }).catch(error => {
      ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
    });
  }

  const featureClicked = (e, objectID, isFeatureTreatment, isFeatureActuals, isFeaturePostFire) => {
    if(!isGroupClick && !isActualsClick){
      if(isFeatureTreatment){
        onTreatmentSelected(objectID, isFeaturePostFire, isFeatureActuals);
      } else {
        onActivitySelected(objectID, isFeaturePostFire, isFeatureActuals);
      }
    }
  }

  const selectFeature = (e, featureAttr, isTreatment, isActuals, fields) => {
    let obj = createFeatureObject(featureAttr, null);
    obj.classID = `${featureAttr[fields.class]}-${featureAttr[FieldNames.featureFields.id]}`;
    const currentFeature = selectedFeatures.filter(x => x.classID === obj.classID);
    if(e.currentTarget.checked) {
      setSelectedFeatures(selectedFeatures => [...selectedFeatures, obj]);
    } else if(!e.currentTarget.checked && currentFeature.length !== 0) {
      const currentFeatureRemoved = selectedFeatures.filter(x => x.classID !== obj.classID)
      setSelectedFeatures(currentFeatureRemoved);
    }
  }

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    if (isCheckAll) {
      setSelectedFeatures([]);
    } else {
        let featureList = [];
        filteredFeatures.forEach((feature) => {
        let obj = createFeatureObject(feature, null);
        obj.classID = `${feature[FieldNames.featureFields.class]}-${feature[FieldNames.featureFields.id]}`;
        featureList.push(obj);
      });
      setSelectedFeatures(featureList);
    }
  };

  const createActual = (isFeatureTreatment, featureAttr) => {
    isActualsClick = true;
    emitCustomEvent(Events.SetActualIsNew, true);
    setSelectedFeatures([featureAttr]);
    const geoType = featureAttr[FieldNames.featureFields.joinFeature]
    if(isFeatureTreatment){
      window.api.getActionByObjectID(featureAttr[FieldNames.featureFields.objectID], geoType).then(plannedFeature => {
        emitCustomEvent(Events.ZoomTo, plannedFeature.geometry)
        setIsCreatingActualFeature(true);
        setIsCreatingPlannedFeature(false);
        setIsTreatment(true);
        setPlannedFeature(plannedFeature);
        dispatch(setIsLocationFilterOnly(false));
        dispatch(setFilterGeometry(null));
      });
    } else {
      window.api.getActionByObjectID(featureAttr[FieldNames.featureFields.objectID], geoType).then(plannedFeature => {
        emitCustomEvent(Events.ZoomTo, plannedFeature.geometry)
        setIsCreatingActualFeature(true);
        setIsCreatingPlannedFeature(false);
        setIsTreatment(false);
        setPlannedFeature(plannedFeature);
        dispatch(setIsLocationFilterOnly(false));
        dispatch(setFilterGeometry(null));
      });
    }
  }

  const reportActual = async (isFeatureTreatment, featureAttributes) => {
    isActualsClick = true;
    if(isFeatureTreatment){
      if(featureAttributes[FieldNames.featureFields.hasActual]){
        await PlannedActualsService.getPlannedActualsByJoinIDs(featureAttributes[FieldNames.featureFields.joinFeature], [featureAttributes[FieldNames.featureFields.joinID]], false).then(async (response) => {
          if(response && response.length > 0){
            const respAttr = response[0]?.attributes ?? response[0];
            await FeatureService.getViewFeatureByJoinValues(respAttr[FieldNames.estimatedActuals.joinIDA], featureAttributes[FieldNames.featureFields.joinFeature], false, FieldNames.featureFields.objectID).then(actualResp => {
              const actualRespAttr = actualResp?.attributes ?? actualResp;
              const plannedActualTreatmentObjectId = actualRespAttr[FieldNames.featureFields.objectID];
              const isActualPostFire = isFeaturePostFire(actualRespAttr);
              const entityStringValue = isActualPostFire ? "pf" : "f";
              if(plannedActualTreatmentObjectId){
                navigate(`/${entityStringValue}/treatments/${plannedActualTreatmentObjectId}`, {isActual: true});
              }
            })
          }
        }).catch(error => {
          ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
        });
        
      } 
    } else {
      if(featureAttributes[FieldNames.featureFields.hasActual]) {
        await PlannedActualsService.getPlannedActualsByJoinIDs(featureAttributes[FieldNames.featureFields.joinFeature], [featureAttributes[FieldNames.featureFields.joinID]], false).then(async (response) => {
          if(response && response.length > 0){
            const respAttr = response[0]?.attributes ?? response[0];
            await FeatureService.getViewFeatureByJoinValues(respAttr[FieldNames.estimatedActuals.joinIDA], respAttr[FieldNames.featureFields.joinFeature], false, FieldNames.featureFields.objectID).then(actualResp => {
              const actualRespAttr = actualResp?.attributes ?? actualResp;
              const plannedActualActivityObjectId = actualRespAttr[FieldNames.featureFields.objectID];
              const isActualPostFire = isFeaturePostFire(actualRespAttr);
              const entityStringValue = isActualPostFire ? "pf" : "f";
              if(plannedActualActivityObjectId){
                navigate(`/${entityStringValue}/activities/${plannedActualActivityObjectId}`, {isActual: true});
              }
            })
            
          }
        }).catch(error => {
          ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
        });
      } 
    }
  }
  
  const navigateToEstimated = async (isFeatureTreatment, featureAttributes) => {
    await FeatureService.getFeatureByObjectID(
      featureAttributes[FieldNames.featureFields.objectID],
      featureAttributes[FieldNames.featureFields.joinFeature],
      false,
      `${FieldNames.featureFields.estimateJoinID}, ${FieldNames.featureFields.estimateJoinFeature}`
    ).then(async (feature) => {
      if(feature?.attributes && feature.attributes[FieldNames.featureFields.estimateJoinID])
      {
        await FeatureService.getViewFeatureByJoinValues(
          feature.attributes[FieldNames.featureFields.estimateJoinID],
          feature.attributes[FieldNames.featureFields.estimateJoinFeature],
          false,
          FieldNames.featureFields.objectID
        ).then((estimateFeature) => {
          if(estimateFeature?.attributes && estimateFeature.attributes[FieldNames.featureFields.objectID])
          {
            const isPostFire = isFeaturePostFire(estimateFeature);
            const entityStringValue = isPostFire ? "pf" : "f";
            if(isFeatureTreatment){
              navigate(`/${entityStringValue}/treatments/${estimateFeature.attributes[FieldNames.featureFields.objectID]}`, {isActual: false});
            } else {
              navigate(`/${entityStringValue}/activities/${estimateFeature.attributes[FieldNames.featureFields.objectID]}`, {isActual: false});
            }
          }
        }).catch(error => {
          ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
        });
      }
    }).catch(error => {
      ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
    });
  }
  const handleToggleDrawer = () => {
    var wasOpen = listOpen;
    setListOpen(!wasOpen);
  };

  const downloadCsv = async (isLimitedToSelected) =>
  {
    try
    {
      if(isLimitedToSelected)
      {
        setShowGlobalLoader(true);
        let allIds = selectedFeatures?.map(f => f[FieldNames.featureFields.objectID]);
        const allActionFundingRows = await getSummaryFundingRowsByActionObjectIds(allIds);
        if(allActionFundingRows?.length > 0)
        {
          const dataRows = await generateFeatureDataPromise(allActionFundingRows);
          if(dataRows)
          {
            let featureSheet = XLSX.utils.aoa_to_sheet(dataRows);
            let csvData = XLSX.utils.sheet_to_csv(featureSheet);
            const blob = new Blob([csvData], {type: "text/csv;charset=utf-8"});
            FileSaver.saveAs(blob, "InFormFuelsFeatureCsvExtract.csv" );
            setActionOpen(false);
            setShowGlobalLoader(false);
          }
        }
        else
        {
          setShowGlobalLoader(false);
        }
      } 
    }
    catch(e)
    {
      ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], e);
      setShowGlobalLoader(false);
    }
  }

  const applyPreferences = () => {
    if(polygonListCount !== tempPolygonListCount){
      setPolygonListCount(tempPolygonListCount);
    } 

    if(lineListCount !== tempLineListCount){
      setLineListCount(tempLineListCount);
    } 

    if(pointListCount !== tempPointListCount){
      setPointListCount(tempPointListCount);
    } 

    if(sortByValue !== tempSortByValue){
      setSortByValue(tempSortByValue);
    }
  }

  const handleCountDialogOpen = (event) => {
    setCountPopupAnchorEl(event.currentTarget);
  };

  const handleCountDialogClose = (event) => {
    setCountPopupAnchorEl(null);
  };

  const handleRadioProjectActionChange = () => {
    if(projectActionSelection === "Actions")
    {
      handleProjectListRadio();
    }
    else
    {
      handleActionListRadio();
    }
  }

  const handleActionListRadio = () => {
    setProjectActionSelection("Actions");
    dispatch(setViewingActions(true));
    dispatch(setViewingProjects(false));
  }

  const handleProjectListRadio = () => {
    setProjectActionSelection("Projects");
    dispatch(setViewingActions(false));
    dispatch(setViewingProjects(true));
  }

  return (
    <Box sx={{ display: 'flex', zIndex: "5!important" }}>
      <CssBaseline />
      <Drawer variant="permanent" open={listOpen} headerheight={headerheight}>
        <DrawerHeader style={{ justifyContent: 'space-between', minHeight: 110, minWidth: 550}}>
          <IconButton onClick={handleToggleDrawer}>
            {listOpen ? <KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
          </IconButton>
          <div style={{ width: 485}}>
            <Box className={listOpen ? '' : 'hidden'}>
              <Stack direction={'column'}>
                <Box>
                  {isUserPostfire ?
                    <RadioGroup
                      row
                      aria-labelledby="filter-controlled-radio-buttons-group"
                      name="filter-controlled-radio-buttons-group"
                      value={projectActionSelection}
                      onChange={handleRadioProjectActionChange}
                      style={{ display: 'flex', justifyContent: 'space-evenly', paddingBottom: 5}}
                    >
                        <FormControlLabel value="Actions" control={<Radio />} label="Actions" />
                        <FormControlLabel value="Projects" control={<Radio />} label="Projects" />
                    </RadioGroup>
                  : null}
                </Box>
                <Box>
                  <Grid container spacing={1} alignItems={'center'}>
                    <Grid size={4}>
                      <InputLabel id="sort-by-value-select" sx={{display: 'inline'}}>{'Sort By: '}</InputLabel>
                      <Select
                        labelId="sort-by-value-select"
                        sx={{ width: 100, height: 40, marginRight: 2 }}
                        value={tempSortByValue}
                        onChange={(event) => {
                          setTempSortByValue(event.target.value)
                        }}
                      >
                        <MenuItem value={""} key="0"><br></br></MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.status} ASC`} key="1">Status ASC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.status} DESC`} key="2">Status DESC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.name} ASC`} key="3">Name ASC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.name} DESC`} key="4">Name DESC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.state} ASC`} key="5">State ASC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.state} DESC`} key="6">State DESC</MenuItem>
                        <MenuItem value={"FY ASC"} key="7">FY ASC</MenuItem>
                        <MenuItem value={"FY DESC"} key="8">FY DESC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.isBIL} ASC`} key="9">IsBil ASC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.isBIL} DESC`} key="10">IsBil DESC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.isCarryover} ASC`} key="11">Is Carryover ASC</MenuItem>
                        <MenuItem value={`${FieldNames.featureFields.isCarryover} DESC`} key="12">Is Carryover DESC</MenuItem>
                      </Select>
                    </Grid>
                    <Grid size={4}>
                      <Button id={countPopupID} style={{ height: 40}} color="primary" variant="contained"
                              onClick={handleCountDialogOpen}>
                              {(activeFilterCountValue > 0 || customFilterInUse) ? 'Show Filtered' : 'Show'}
                      </Button>
                      <Popover 
                        id={countPopupID}
                        open={countPopupOpen}
                        anchorEl={countPopupAnchorEl}
                        onClose={handleCountDialogClose}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                      >
                        <Stack>
                          <Typography sx={{textAlign: "center", fontWeight: "bold"}}>List Card Count(s)</Typography>
                          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                              <Typography>Polygons:</Typography>
                              <Select
                                value={tempPolygonListCount}
                                onChange={(event) => {
                                  setTempPolygonListCount(event.target.value)
                                }}
                              >
                                <MenuItem value={0}>0</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={200}>200</MenuItem>
                                <MenuItem value={300}>300</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                              <Stack direction="row">
                                <Typography>Lines:</Typography>
                                { (!isUserPostfire || isFilterFuelsOnly) ?
                                  <Tooltip
                                  title={
                                    <span style={{ whiteSpace: 'pre-line' }}>Lines and Points are not currently available for Fuels.</span>
                                  } 
                                  enterDelay={100}
                                >
                                  <InfoIcon fontSize="medium" color="primary"/>
                                </Tooltip> : null
                                }
                              </Stack>
                              <Select
                                value={tempLineListCount}
                                onChange={(event) => {
                                  setTempLineListCount(event.target.value)
                                }}
                                disabled={!isUserPostfire || isFilterFuelsOnly}
                              >
                                <MenuItem value={0}>0</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={200}>200</MenuItem>
                                <MenuItem value={300}>300</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                              <Stack direction="row">
                                <Typography>Points:</Typography>
                                { (!isUserPostfire || isFilterFuelsOnly) ?
                                  <Tooltip
                                  title={
                                    <span style={{ whiteSpace: 'pre-line' }}>Lines and Points are not currently available for Fuels.</span>
                                  } 
                                  enterDelay={100}
                                >
                                  <InfoIcon fontSize="medium" color="primary"/>
                                </Tooltip> : null
                                }
                              </Stack>
                              <Select
                                value={tempPointListCount}
                                onChange={(event) => {
                                  setTempPointListCount(event.target.value)
                                }}
                                disabled={!isUserPostfire || isFilterFuelsOnly}
                              >
                                <MenuItem value={0}>0</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={200}>200</MenuItem>
                                <MenuItem value={300}>300</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                          <Button style={{ height: 40}} sx={{marginBottom: '2.5px', marginLeft: '2.5px', marginRight: '2.5px'}} color="primary" variant="contained" onClick={() => handleCountDialogClose()}>
                            Close
                          </Button>
                        </Stack>
                      </Popover>
                    </Grid>
                    <Grid size={1}/>
                    <Grid size={1}>
                      { (areListCountsDifferent || sortByValue !== tempSortByValue) &&
                        <Tooltip title="The Apply button must be clicked to apply preferences" enterDelay={400}>
                          <WarningAmberIcon style={{ color: ColorConstants.StatusColors.Draft, fontSize: 40, verticalAlign: 'middle'}} />
                        </Tooltip>
                      }
                    </Grid>
                    <Grid size={2}>
                      <Button style={{ height: 40}} color="primary" variant="contained" onClick={() => applyPreferences()}>
                        Apply
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
            </Box>
          </div>
        </DrawerHeader>
        <Divider />
        <div className="incidentList-panel">
          <div className={listOpen ? 'incidentList-buttons': 'incidentList-buttons hidden'}>
            <Grouping userInfo={userInfo} selectedFeatures={selectedFeatures} setSelectedFeatures={setSelectedFeatures} associateOpen={associateOpen} 
              groupingsOpen={groupingsOpen} setGroupingsOpen={setGroupingsOpen} 
              featureGroupIds={featureGroupIds} setFeatureGroupIds={setFeatureGroupIds} featureGroupItems={featureGroupItems} 
              setFeatureGroupItems={setFeatureGroupItems} associateHandleClose={associateHandleClose} associatedCount={groupingCounts} setAssociatedCount={setGroupingCounts} isLoading={false} 
              treatments={treatments} activities={activities} featureGroups={featureGroups} actualTreatments={actualTreatments} actualActivities={actualActivities} setIsLoading={setIsLoading} isFromList={true}
            />
            <div className='blue-msg' >
              <div>
                <Checkbox
                  type="checkbox"
                  name="selectAll"
                  id="selectAll"
                  onChange={(e) => { handleSelectAll(e)}}
                  checked={isCheckAll}
                />
                <InputLabel id='selectAll' sx={{display: 'inline'}}>
                  Select All
                </InputLabel>
                {/* If we ever need the radios to be stacked again, width=55, marginTop=0, flexDirection=column */}
                <FormControl sx={{width: 150, height: 40, marginTop: 1.5, marginLeft: 2, display: 'inline-flex', flexDirection: 'row'}}>
                  <RadioGroup row value={cardSize} onChange={(event) => {setCardSize(event.target.value)}}>
                    <FormControlLabel sx={{fontSize: '1rem', height: 15, marginBottom: 1 }} value={FieldNames.listCardTypes.condensed} control={<Radio style={{padding: 0, display: 'inline'}} />} label={FieldNames.listCardTypeNames.condensed} />
                    <FormControlLabel sx={{fontSize: '1rem', height: 15}} value={FieldNames.listCardTypes.detailed} control={<Radio style={{padding: 0, display: 'inline'}} />} label={FieldNames.listCardTypeNames.detailed} />
                  </RadioGroup>
                </FormControl>
              </div>
              
              <div>
                <ButtonGroup variant="outlined" ref={anchorRef} aria-label="split button">
                  <Button color="primary" size="small" style={{ height: '30px' }}>Map Actions</Button>
                  <Button
                    size="small"
                    color="primary"
                    aria-controls={actionOpen ? 'split-button-menu' : undefined}
                    aria-expanded={actionOpen ? 'true' : undefined}
                    aria-label="actionsDrowdown"
                    aria-haspopup="menu"
                    style={{ height: '30px', minWidth: '20px', width: '30px'}}
                    onClick={handleActionToggle}>
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
                <Popper
                  open={actionOpen}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                  style={{ maxWidth: '300px', zIndex: 5}}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === 'bottom' ? 'center top' : 'center bottom',
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleActionClose}>
                          <MenuList id="split-button-menu" autoFocusItem>
                              <MenuItem onClick={() => onAssociate()}>
                                Associate
                              </MenuItem>
                              {/* <MenuItem onClick={() => downloadCsv(false)}>
                                Download CSV
                              </MenuItem> */}
                              <MenuItem onClick={() => downloadCsv(true)}>
                                Export Selected Data
                              </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </div>
          </div>
          <div className="incident-list" style={{ height: '66vh'}}>
            <div className="incident-list-inner" style={{ display: "flex", flexGrow: 1 }}>
            <AutoSizer>
              {({ height, width }) => (
                <ListCard height={height} width={listOpen ? width : 64} data={filteredFeatures} featureClicked={featureClicked} selectFeature={selectFeature} 
                  selectedFeatures={selectedFeatures} onGroupEdit={onGroupEdit} createActual={createActual} reportActual={reportActual} navigateToEstimated={navigateToEstimated}
                  listOpen={listOpen} cardSize={cardSize} userInfo={userInfo} isGroupingsLoading={isGroupingsLoading}/>
              )}
              </AutoSizer>
            </div>
          </div>
          <div className={listOpen ? 'incidentList-bottom': 'incidentList-bottom hidden'}>
            <MapLegend/>          
          </div>
        </div>
      </Drawer>
    </Box>
  );
}